/**
 * CSS の `url()` に画像パスを安全に埋め込む。
 *
 * 引用符なしの url() トークンには半角丸括弧・空白・引用符を入れられないため、
 * 例えば `/images/case/new/⑭K邸(車庫）/1.jpg` のような実在パスを素で渡すと
 * 宣言ごと無効になり画像が出なくなる。引用符で囲み、さらに encodeURI する。
 */
export default function cssUrl(path) {
  return `url("${encodeURI(path).replace(/"/g, '%22')}")`;
}
